'use es6';

import PropTypes from 'prop-types';
import { SelectReportCheckbox } from '../../common/SelectReportCheckbox';
import { jsx as _jsx } from "react/jsx-runtime";
const CheckboxCell = props => {
  return /*#__PURE__*/_jsx("td", {
    children: /*#__PURE__*/_jsx(SelectReportCheckbox, Object.assign({}, props))
  });
};
CheckboxCell.propTypes = {
  isDisabled: PropTypes.bool,
  isSelected: PropTypes.bool.isRequired,
  handleSelectedChange: PropTypes.func.isRequired,
  tooltipMessage: PropTypes.node,
  isInTable: PropTypes.bool
};
export default CheckboxCell;